import React from "react";
import { Toaster } from "sonner";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "@/App.css";

import { AccountProvider } from "@/lib/account";
import { LangProvider } from "@/lib/lang";
import { useAutoPurgeOnExit } from "@/lib/privacy";
import { FavoritesProvider } from "@/components/Favorites";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import CharacterGallery from "@/components/CharacterGallery";
import Decouvrir from "@/components/Decouvrir";
import Barde from "@/components/Barde";
import Druide from "@/components/Druide";
import Guantrai from "@/components/Guantrai";
import Phanes from "@/components/Phanes";
import OracleDelphe from "@/components/OracleDelphe";
import ElementChat from "@/components/ElementChat";
import ElementsHub from "@/components/ElementsHub";
import ScrollToTop from "@/components/ScrollToTop";
import { AiBanner, AiConsentModal } from "@/components/AiNotice";
import Footer from "@/components/Footer";
import Privacy from "@/components/Privacy";
import Taverne from "@/components/Taverne";
import Vate from "@/components/Vate";
import Gaia from "@/components/Gaia";
import AhuraMazda from "@/components/AhuraMazda";
import Dagda from "@/components/Dagda";
import Suantrai from "@/components/Suantrai";
import Farfadet from "@/components/Farfadet";
import Korrigan from "@/components/Korrigan";
import Grammarien from "@/components/Grammarien";
import Traditions from "@/components/Traditions";
import Urantia from "@/components/Urantia";
import Zeus from "@/components/Zeus";
import Apollon from "@/components/Apollon";
import Eros from "@/components/Eros";
import AmisDesCeltes from "@/components/AmisDesCeltes";
import Geantrai from "@/components/Geantrai";
import DebatOlympien from "@/components/DebatOlympien";
import Polyglotte from "@/components/Polyglotte";
import AngesGuides from "@/components/AngesGuides";
import Archange from "@/components/Archange";

function Home() {
  useAutoPurgeOnExit(true);
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CharacterGallery />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <LangProvider>
      <AccountProvider>
        <FavoritesProvider>
          <div className="App pb-16 sm:pb-8">
          <Toaster
            position="top-center"
            theme="dark"
            richColors
            toastOptions={{
              style: {
                background: "rgba(14, 8, 32, 0.92)",
                border: "1px solid rgba(212, 175, 55, 0.35)",
                color: "#f8f4ff",
                backdropFilter: "blur(14px)",
              },
            }}
          />
          <BrowserRouter>
            <ScrollToTop />
            <AiConsentModal />
            <AiBanner />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/pub" element={<Taverne />} />
              <Route path="/taverne" element={<Taverne />} />
              <Route path="/suantrai" element={<Suantrai />} />
              <Route path="/vate" element={<Vate />} />
              <Route path="/gaia" element={<Gaia />} />
              <Route path="/ahura" element={<AhuraMazda />} />
              <Route path="/dagda" element={<Dagda />} />
              <Route path="/farfadet" element={<Farfadet />} />
              <Route path="/korrigan" element={<Korrigan />} />
              <Route path="/grammarien" element={<Grammarien />} />
              <Route path="/traditions" element={<Traditions />} />
              <Route path="/urantia" element={<Urantia />} />
              <Route path="/zeus" element={<Zeus />} />
              <Route path="/apollon" element={<Apollon />} />
              <Route path="/eros" element={<Eros />} />
              <Route path="/amis-des-celtes" element={<AmisDesCeltes />} />
              <Route path="/geantrai" element={<Geantrai />} />
              <Route path="/debat-olympien" element={<DebatOlympien />} />
              <Route path="/polyglotte" element={<Polyglotte />} />
              <Route path="/anges-guides" element={<AngesGuides />} />
              <Route path="/anges/:id" element={<Archange />} />
              <Route path="/decouvrir" element={<Decouvrir />} />
              <Route path="/barde" element={<Barde />} />
              <Route path="/druide" element={<Druide />} />
              <Route path="/guantrai" element={<Guantrai />} />
              <Route path="/elements" element={<ElementsHub />} />
              <Route path="/elements/:id" element={<ElementChat />} />
              <Route path="/phanes" element={<Phanes />} />
              <Route path="/oracle-delphe" element={<OracleDelphe />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </div>
        </FavoritesProvider>
      </AccountProvider>
    </LangProvider>
  );
}

export default App;
